import type { LoaderFunctionArgs } from "react-router-dom";
import { redirect } from "react-router-dom";

import { fromHandling } from "./utils";

// import { path } from "@routes/path.ts";
import { useUserStore } from "@/stores/userStore";
import { routePath } from "@routes/path.ts";
import { IAuthStepEnum } from "@/templates/authManagement";
// import { IAuthStepEnum } from "@/template/authManagement/authStore";
// import { path } from "@routes/path.ts";

/**
If the user is not logged in we redirect
them to `/login` with a `from` parameter that allows login to redirect back
to this page upon successful authentication
 */
export function protectedLoader({ request: _request }: LoaderFunctionArgs) {
  // we don't need reactive state here
  const state = useUserStore.getState();

  if (!state.token) {
    // const fromParam = fromHandling.createFromParam(request);
    return redirect(
      routePath.authManagement.auth({ type: IAuthStepEnum.LOGIN?.toString() }),
    );
    // return redirect(`${path.auth.login.link()}?${fromParam}`);
  }
  return null;
}

/**
if user is already logged in, redirect to `from` or `/`
 */
export function loginLoader({ request }: LoaderFunctionArgs) {
  // we don't need reactive state here
  const state = useUserStore.getState();

  if (state.token) {
    const fromParam = fromHandling.getFromParmaValue(request);

    return redirect(fromParam || "/");
  }
  return null;
}

/*
useUserStore.subscribe(
  (state) => state.role,
  () => window.location.reload()
)
*/
